module.exports = __webpack_public_path__ + "media/images/ments_kutyat-beb07bcf23f21b61b01b803db3fc65fa.jpg";